import PropTypes from "prop-types";

import CategoryPresenter from "presenters/CategoryPresenter";
import PageHeader from "components/PageHeader";

const CategoryHeader = ({ category, loading }) => {
  const cumpleanosDesc =
    "¡Pastel! ¡Velas! ¡Tarjetas Digitales de Cumpleaños! La lista perfecta para una única y estupenda celebración para todas las edades.";
  const title = CategoryPresenter.isCumpleanos(category)
    ? "Tarjetas de Feliz Cumpleaños"
    : CategoryPresenter.displayName(category);
  const description = CategoryPresenter.isCumpleanos(category)
    ? cumpleanosDesc
    : CategoryPresenter.description(category);

  return <PageHeader title={title} description={description} loading={loading} />;
};

CategoryHeader.propTypes = {
  category: PropTypes.shape(),
  loading: PropTypes.bool,
};

export default CategoryHeader;
